import { combineReducers } from 'redux';
import confirmPasswordReducer from './ConfirmPasswordReducer';
import customizationReducer from './CustomizationReducer';
import loadingReducer from './LoadingReducer';
import otpReducer from './OtpReducer';
import redirectReducer from './RedirectFromModalReducer';
import signupReducer from './SignUpReducer';

// ==============================|| COMBINE REDUCER ||============================== //

const Reducer = combineReducers({
  customization: customizationReducer,
  otp: otpReducer,
  password: confirmPasswordReducer,
  signup: signupReducer,
  loading: loadingReducer,
  redirectModal: redirectReducer,
});

export default Reducer;
